import React from 'react';
import MetaTags from '../../../components/MetaTags';
import { WalletView } from './WalletView';
import { useWallet } from './useWallet';

export const Wallet: React.FC = () => {
    const { metaTags, ...viewProps } = useWallet();
    return (
        <React.Fragment>
            <MetaTags {...metaTags} />
            <WalletView {...viewProps} />
        </React.Fragment>
    );
};
